import { render, staticRenderFns } from "./NewTabDocuments.vue?vue&type=template&id=0841dd05&"
import script from "./NewTabDocuments.vue?vue&type=script&lang=js&"
export * from "./NewTabDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports